import { FC } from "react";
import { Icon } from "@/components/Common/Icon";
import { Button } from "@/components/Base/Button";
import { CardGroup } from "../types";

export interface GroupHeaderProps {
  group: CardGroup;
  showStatistics: boolean;
  showCounts: boolean;
  onToggleCollapse: (groupId: string) => void;
}

export const GroupHeader: FC<GroupHeaderProps> = ({
  group,
  showStatistics,
  showCounts,
  onToggleCollapse,
}) => {
  const { id, label, cards, statistics, isCollapsed } = group;

  const formatHours = (hours: number): string => {
    return hours.toFixed(1);
  };

  return (
    <div className="sticky top-0 z-10 border-b border-slate-700 bg-muted/50">
      <div className="flex items-center justify-between p-3">
        <div className="flex items-center gap-3">
          {/* Collapse/Expand Button */}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onToggleCollapse(id)}
            className="h-6 w-6 p-0"
          >
            <Icon
              name={isCollapsed ? "chevronRight" : "chevronDown"}
              size={14}
            />
          </Button>

          {/* Group Label */}
          <div className="flex items-center gap-2">
            <h3 className="text-sm font-semibold text-foreground">
              {label || "Ungrouped"}
            </h3>
            {showCounts && (
              <span className="rounded bg-muted px-2 py-1 text-xs text-muted-foreground">
                {cards.length} {cards.length === 1 ? "card" : "cards"}
              </span>
            )}
          </div>
        </div>

        {/* Statistics */}
        {showStatistics && !isCollapsed && (
          <div className="flex items-center gap-4 text-xs text-muted-foreground">
            {/* Total Labor Hours */}
            <div className="flex items-center gap-1">
              <Icon name="clock" size={12} />
              <span>{formatHours(statistics.totalLaborHours)}h total</span>
            </div>

            {/* Average Labor Hours */}
            {statistics.cardCount > 0 && (
              <div className="flex items-center gap-1">
                <Icon name="barChart" size={12} />
                <span>{formatHours(statistics.averageLaborHours)}h avg</span>
              </div>
            )}

            {/* Promise Time Violations */}
            {statistics.promiseTimeViolations > 0 && (
              <div className="flex items-center gap-1 text-orange-600">
                <Icon name="alertTriangle" size={12} />
                <span>{statistics.promiseTimeViolations} overdue</span>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
